import { render } from "./RatingTopmarq.vue?vue&type=template&id=95836f1e"
import script from "./RatingTopmarq.vue?vue&type=script&lang=js"
export * from "./RatingTopmarq.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__